import React, { useState } from "react";

import { useTranslation } from "utils";

import { CarbonProgram, ENROLLMENT_TYPE, FieldListField } from "models";

import { BulkFieldContextMenu, ContextMenu, IconButton, Message } from "components";

import { FieldDeletionDrawer } from "pages/app/fields/components/FieldDeletionDrawer";

// shared toolbar "+" button (Add/Enroll/Delete fields) for Timeline/Map/Table view; Add/Enroll stay caller-owned
export const FieldToolbarAddMenu = ({
  fields,
  carbonProgram,
  isSoilPlus3DataGapFeatureActive,
  isDataSubmitted,
  fieldsWithOpenTasksCount,
  onAddFields,
  onEnrollFields,
}: {
  fields: FieldListField[] | undefined;
  carbonProgram: CarbonProgram | null | undefined;
  isSoilPlus3DataGapFeatureActive: boolean;
  isDataSubmitted: boolean;
  fieldsWithOpenTasksCount: number;
  onAddFields: () => void;
  onEnrollFields: () => void;
}) => {
  const { t } = useTranslation("allFieldView");
  const [visible, setVisible] = useState(false);
  const [showDeletionDrawer, setShowDeletionDrawer] = useState(false);

  return (
    <>
      {
        // TODO: Remove feature flag
        isSoilPlus3DataGapFeatureActive || carbonProgram?.fieldsManagement?.fieldEnrollmentType === ENROLLMENT_TYPE.user ? (
          <BulkFieldContextMenu
            visible={visible}
            onClose={() => setVisible(false)}
            allFields={fields ?? []}
            onEnrollFields={() => {
              onEnrollFields();
              setVisible(false);
            }}
            onAddFields={() => {
              onAddFields();
              setVisible(false);
            }}
            onDeleteFields={() => {
              setShowDeletionDrawer(true);
              setVisible(false);
            }}
            fieldsWithOpenTasksCount={fieldsWithOpenTasksCount}
          >
            <IconButton onClick={() => setVisible(true)} iconName="klim/plus" size="small" type="tertiary" />
          </BulkFieldContextMenu>
        ) : (
          <ContextMenu
            items={[
              {
                iconName: "klim/plus",
                label: t("fieldContextMenu.addFields"),
                state: isDataSubmitted ? "disabled" : undefined,
                onClick: () => {
                  if (isDataSubmitted) {
                    Message({ content: t("fieldContextMenu.addFieldsDisabledForSubmittedData"), icon: "error" });
                    return;
                  }
                  onAddFields();
                },
              },
              {
                iconName: "tabler/trash",
                label: t("fieldContextMenu.deleteFields"),
                state: fields?.length ? "warning" : "disabled",
                onClick: () => setShowDeletionDrawer(true),
              },
            ]}
            placement="right"
            visible={visible}
            iconSize="m-light"
            onClose={() => setVisible(false)}
          >
            <IconButton onClick={() => setVisible(true)} iconName="klim/plus" size="small" type="tertiary" />
          </ContextMenu>
        )
      }
      <FieldDeletionDrawer
        fields={fields ?? []}
        visible={showDeletionDrawer}
        onClose={() => setShowDeletionDrawer(false)}
        onDelete={() => {}}
        carbonProgram={carbonProgram}
      />
    </>
  );
};
